import { useNavigate, useParams } from "react-router-dom"
import PaymentsTable from "./payments-table"
import { PaymentDetailsSheet } from "./payment-details.sheet"

export default function PaymentsHomeScreen() {
  const { paymentId } = useParams()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row justify-between">
        <div className="text-xl font-semibold">Payments</div>
      </div>
      <PaymentsTable infinite />
      {paymentId && (
        <PaymentDetailsSheet
          id={paymentId}
          onClose={() => navigate("/payments")}
        />
      )}
    </div>
  )
}
